export default {
  getAccountMap: (state) => state.accountMap,
};
